import type { OfferExposeSection } from "@slfinrtl/ui-bff-routes"

const BASE_EXPOSE_SECTIONS: OfferExposeSection[] = [
	"vehicleImages",
	"specialEquipment",
	"standardEquipment",
	"technicalData",
]

export const getInitialExposeSections = (isExposeTyreLabelsAvailable: boolean): OfferExposeSection[] =>
	isExposeTyreLabelsAvailable ? [...BASE_EXPOSE_SECTIONS, "tyreLabels"] : BASE_EXPOSE_SECTIONS
